import "./CSS/right-side-drawer.scss";

import { Channel, Topic, RightSideDrawerCloseReason } from "../../constants";
import { MessageBrokerUtils, TrackingUtils } from "../../utils";
import React, { useEffect, useState } from "react";
import { UISelectors } from "../../redux/selectors";
import { useClickOutside } from "../../hooks";
import { RightSideDrawerError } from "./RightSideDrawerError";
import { useSelector } from "react-redux";

const RightSideDrawer = () => {
  const rightSideDrawer = useSelector(UISelectors.rightSideDrawer);
  const [ignoringClickOutside, setIgnoringClickOutside] = useState(true);
  const [showRightSideDrawer, setShowRightSideDrawer] = useState(null);
  const [rightSideDrawerSize, setRightSideDrawerSize] = useState(0);

  useEffect(() => {
    setIgnoringClickOutside(true);
    const timeout = setTimeout(() => {
      setIgnoringClickOutside(false);
      clearTimeout(timeout);
    }, 200);
    const shownDrawer = getShawnDrawerElement(rightSideDrawer);
    setShowRightSideDrawer(shownDrawer);
    const newDrawerSize = rightSideDrawer.length;
    if (rightSideDrawerSize !== newDrawerSize) {
      setRightSideDrawerSize(newDrawerSize);
    }
    if (rightSideDrawerSize < newDrawerSize) {
      appContainerReady(shownDrawer);
    }
  }, [rightSideDrawer, rightSideDrawerSize]);

  const appContainerReady = data => {
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.appContainerReady,
      headers: {
        publisher: "UAA"
      },
      data
    });
  };

  const getShawnDrawerElement = rightSideDrawer => {
    let selected = null;
    const reversedDrawer = rightSideDrawer.slice().reverse();
    for (let drawer of reversedDrawer) {
      if (drawer.isVisible && !drawer.isMinimized) {
        selected = drawer;
        break;
      }
    }
    return selected;
  };

  const publishAppClosing = (drawer, isOverlay) => {
    const { appID, correlationID, launchInfo } = drawer;
    const closeReason = isOverlay
      ? RightSideDrawerCloseReason.OutsideClick
      : RightSideDrawerCloseReason.ManualXBtn;
    const clickedEl = isOverlay ? "Overlay" : "Close button";
    MessageBrokerUtils.publish({
      channel: Channel.SESSION,
      topic: Topic.appClosing,
      headers: {
        publisher: "UAA"
      },
      data: {
        appID,
        correlationID,
        launchInfo: {
          ...launchInfo,
          channel: {
            source: "Unified Client",
            area: clickedEl,
            element: clickedEl
          }
        },
        closeReason
      }
    });
  };

  const onOutsideClicked = () => {
    const reversedDrawer = rightSideDrawer.slice().reverse();
    const size = reversedDrawer.length;
    if (size < 1) return;

    for (let drawer of reversedDrawer) {
      const { appID, isMinimized, trackingInfo } = drawer;
      if (isMinimized) continue;

      if (trackingInfo?.closeTracking) {
        TrackingUtils.sendAnalytics(
          rightSideDrawer.trackingInfo?.closeTracking(appID)
        );
      }
      publishAppClosing(drawer, true);
    }
  };

  const currentRef = useClickOutside(onOutsideClicked, {
    ignoreClass: ["do-not-close-right-side-drawer", "bubble"],
    disabled: ignoringClickOutside || !showRightSideDrawer
  });

  const onClose = drawer => {
    const { appID, trackingInfo } = drawer;
    if (trackingInfo?.closeTracking) {
      TrackingUtils.sendAnalytics(
        rightSideDrawer.trackingInfo?.closeTracking(appID)
      );
    }
    publishAppClosing(drawer, false);
  };

  const onRetry = (drawer = {}) => {
    if (typeof drawer.callback === "function") {
      if (drawer.trackingInfo?.retryTracking) {
        TrackingUtils.sendAnalytics(drawer.trackingInfo?.retryTracking);
      }
      console.log("[RightSideDrawer] Calling retry callback...");
      drawer.callback();
    }
  };

  return (
    <div
      className={`right-side-drawer do-not-close-right-side-drawer ${
        showRightSideDrawer ? "show-rsd" : ""
      }`}
      ref={currentRef}
    >
      {rightSideDrawer.length > 0 && (
        <>
          {rightSideDrawer.map(drawer => {
            const { appID, isVisible, error, containerID } = drawer;
            if (isVisible && error) {
              return (
                <RightSideDrawerError
                  key={`${appID}_error`}
                  drawer={drawer}
                  onClose={() => onClose(drawer)}
                  onRetry={() => onRetry(drawer)}
                />
              );
            } else if (appID) {
              const displayStatus =
                showRightSideDrawer && showRightSideDrawer.appID === appID;
              return (
                <div
                  id={containerID}
                  key={appID}
                  className={`drawer-application-container ${
                    displayStatus ? "show-drawer-item" : "hide-drawer-item"
                  }`}
                />
              );
            }
          })}
        </>
      )}
    </div>
  );
};
export default RightSideDrawer;
